<template>
    <div class="col-lg-10">
        <h1 class="text-muted mb-4">            
            Billing
        </h1>
        <div class="d-flex justify-content-end">
             <button class="btn btn-outline-success">Make payment</button>
        </div>
        <div class="mt-3">
            <div class="border rounded p-5 ">
                <h2>Estimated Due</h2>
                <p>This is an estimate of the amount you owe based on your current month-to-date usage after credits & prepayments.</p>
                <h2>$ 0 </h2>
                <div class="mt-3 d-flex justify-content-between">
                    <div class="d-flex flex-column">
                        payment Due
                        <small>$ 0</small>
                    </div>
                    <div class="d-flex flex-column">
                        prepayment
                        <small>$ 0</small>
                    </div>
                    <div class="d-flex flex-column">
                        total Usage
                        <small>$ 0</small>
                    </div>
                    <div class="d-flex flex-column">
                        Estimated Due
                        <small>$ 0</small>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    export default {
        name: 'billing',        
        data(){
            return{
              
            }
        },       

        methods:{		

        }
    }
</script>
      